import { getCookie } from 'cookies-next'
import { GetServerSideProps, NextPage } from 'next'
import { NextSeo } from 'next-seo'

import { gql } from '@apollo/client'
import AddCoupon from 'Root/Pages/AddCoupon'
import apolloClient from 'lib/apollo-client'
import getQueryString from 'lib/get-query-string'
import { loadCatalog } from 'lib/i18n'
import { useIsClient } from 'lib/use-is-client'

interface IGetUserData {
  me?: {
    email: string
  }
}

export interface AppSumoPageProps {
  accessToken: string
  userEmail: string | null
}

const Page: NextPage = ({ accessToken, userEmail }: AppSumoPageProps) => {
  const isClient = useIsClient()

  if (!isClient) return null

  return (
    <>
      <NextSeo
        openGraph={{
          title: 'Taylora – Redeem SaasZilla Code',
          images: [
            {
              width: 1920,
              height: 1080,
              type: 'image/png',
              url: 'https://taylora.com/taylora-saaszilla-banner.png',
            },
          ],
        }}
        title="Taylora – Redeem SaasZilla Code"
        description="Redeem your SaasZilla Lifetime code for Taylora and start sharing and selling video lessons, eBooks, and courses with ease. Unlock your Lifetime access today!"
      />
      <AddCoupon accessToken={accessToken} userEmail={userEmail} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
}) => {
  const translation = await loadCatalog(getQueryString(query.locale))
  const accessToken = getCookie('access_token', { req, res })

  const { data } = await apolloClient.query<IGetUserData>({
    query: gql`
      query GET_USER_EMAIL {
        me {
          email
        }
      }
    `,
    context: {
      headers: {
        Authorization: Boolean(accessToken) ? `Bearer ${accessToken}` : '',
      },
    },
  })

  return {
    props: {
      translation: translation,
      accessToken: typeof accessToken === 'string' ? accessToken : '',
      userEmail: data.me?.email ?? null,
    },
  }
}

export default Page
